import { Injectable } from "@angular/core";
import { IPayload } from "src/app/interface/filters";

@Injectable({
    providedIn: "root",
})
export class FlagUniqueService {

    private _flagUnique: string = "true";

    get flagUnique(): string {
        return this._flagUnique;
    }

    set flagUnique(value: string) {
        this._flagUnique = value;
    }

    /**
     * Serializes a payload while ignoring the FlagUnique filter, so it can be used
     * as a comparison key (e.g. in distinctUntilChanged) that does not react to
     * FlagUnique changes.
     */
    payloadWithoutFlagUnique(p: IPayload): string {
        const { FlagUnique, ...extraFiltersWithoutFlag } = p.extraFilters ?? {};
        return JSON.stringify({ ...p, extraFilters: extraFiltersWithoutFlag });
    }

}